export const environment = {
  production: false,
  name: 'development',
  CalystaApiBaseURL: 'https://calystaadminapi-test.azurewebsites.net/',
  PatriciaBaseURL: 'http://patricia.calysta.eu/pat',
  // crystal-web Sentry project (calysta-nv org). NOT the same DSN as CalystaAdminAPI's
  // crystal-api project -- frontend and backend are two projects, linked by distributed tracing.
  sentryDsn: 'https://ad08f21c678ddb3f015fc849f65e4b2a@o4506547350142976.ingest.us.sentry.io/4506547398246400',
  authBypass: false
};
